import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import ruleService from "../../../../services/web/rule-service";

export function useRuleData(ruleId) {
    const formInfoRes = useQuery({
        queryKey: ["alarmRuleFormInfo", ruleId],
        queryFn: async () => {
            const res = await ruleService.formInfo(ruleId);

            let raw = res;
            if (typeof raw === "string") {
                try {
                    raw = JSON.parse(raw);
                } catch {
                    raw = {};
                }
            };

            const options = raw?.options ?? {};
            const dataNode = raw?.data ?? {};

            return {
                lanes: options.lanes ?? [],
                devices: options.devices ?? [],
                visibilities: options.visibilities ?? [],
                reasons: options.reasons ?? [],
                monitoringTypes: options.monitoringTypes ?? [],
                dows: options.dow ?? [],
                selectedDevices: dataNode.selectedDevices ?? [],
                alarmRule: dataNode.alarmRule ?? null,
            };
        },
    });

    const isAnyLoading = formInfoRes.isLoading;
    const isAnyError = formInfoRes.isError;
    const data = formInfoRes.data ?? {};

    return useMemo(
        () => ({
            visibilityOptions: (data.visibilities ?? []).map(v => ({
                value: String(v.id),
                label: v.text,
            })),
            typeOptions: (data.monitoringTypes ?? []).map(t => ({
                value: String(t.id),
                label: t.text,
            })),
            reasonOptions: (data.reasons ?? []).map(r => ({
                value: String(r.id),
                label: r.text,
            })),
            laneOptions: (data.lanes ?? []).map(l => ({
                value: String(l.id),
                label: l.text,
            })),
            dowOptions: (data.dows ?? []).map(d => ({
                value: String(d.id),
                label: d.text,
            })),
            deviceOptions: (data.devices ?? []).map(d => ({
                value: String(d.id),
                label: d.text,
            })),
            devicesFetched: data.selectedDevices ?? [],
            initialRule: data.alarmRule ?? null,
            isAnyLoading,
            isAnyError,
            refetch: formInfoRes.refetch,
        }),
        [data, isAnyLoading, isAnyError, formInfoRes.refetch]
    );
}
